import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from "@material-ui/core";

interface ICustomNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (title: string, body: string) => void;
  notificationTitle: string;
  setNotificationTitle: (title: string) => void;
  notificationBody: string;
  setNotificationBody: (body: string) => void;
}

export const CustomNotificationModal: React.FC<ICustomNotificationModalProps> = ({
  isOpen,
  onClose,
  onSend,
  notificationTitle,
  setNotificationTitle,
  notificationBody,
  setNotificationBody
}) => {
  const handleSend = () => {
    onSend(notificationTitle, notificationBody);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Send Custom Notification</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Notification Title"
          type="text"
          fullWidth
          variant="outlined"
          value={notificationTitle}
          onChange={(e) => setNotificationTitle(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Notification Body"
          type="text"
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={notificationBody}
          onChange={(e) => setNotificationBody(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleSend}
          color="primary"
          disabled={!notificationTitle || !notificationBody}
        >
          Send Notification
        </Button>
      </DialogActions>
    </Dialog>
  );
};

